import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../service/loading/loading.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor( private loadingService: LoadingService ) {
    // Intentionally blank
  }

  intercept( request: HttpRequest<unknown>, next: HttpHandler ): Observable<HttpEvent<unknown>> {
    this.loadingService.setLoading( false );
    return next.handle( request );
  }
}
